import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { config } from '../../config';

export default function DashboardEnseignant() {
  const [stats, setStats] = useState({ total_cours: 0, revenus_totaux: 0, total_etudiants: 0 });
  const [coursRecents, setCoursRecents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Utilisation de la configuration centralisée
  const API_BASE = config.apiBase;
  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = getToken();
        const statsRes = await fetch(`${API_BASE}/enseignant/cours/get_stats.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const statsData = await statsRes.json();
        if (statsData.success) setStats(statsData.stats);
        
        const coursRes = await fetch(`${API_BASE}/enseignant/cours/get_mes_cours.php`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const coursData = await coursRes.json();
        if (coursData.success) setCoursRecents(coursData.cours.slice(0, 5));
      } catch (error) {
        toast.error('Erreur de chargement');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">👨‍🏫 Tableau de bord enseignant</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl p-6 text-white shadow-lg">
          <div className="text-4xl mb-2">📚</div>
          <p className="text-sm opacity-90">Total cours</p>
          <p className="text-3xl font-bold">{stats.total_cours || 0}</p>
        </div>
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg">
          <div className="text-4xl mb-2">💰</div>
          <p className="text-sm opacity-90">Revenus totaux</p>
          <p className="text-3xl font-bold">{stats.revenus_totaux?.toLocaleString() || 0} F</p>
        </div>
        <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl p-6 text-white shadow-lg">
          <div className="text-4xl mb-2">🎓</div>
          <p className="text-sm opacity-90">Étudiants</p>
          <p className="text-3xl font-bold">{stats.total_etudiants || 0}</p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-gray-800">📖 Cours récents</h2>
          <button onClick={() => navigate('/enseignant/cours')} className="text-blue-600 hover:underline text-sm">Voir tout →</button>
        </div>
        {coursRecents.length === 0 ? (
          <div className="text-center py-8"><p className="text-gray-500">Aucun cours pour le moment</p></div>
        ) : (
          <div className="space-y-3">
            {coursRecents.map(cours => (
              <div key={cours.id_cours} className="flex justify-between items-center p-3 hover:bg-gray-50 rounded-lg border">
                <div><h3 className="font-medium text-gray-800">{cours.titre}</h3><p className="text-sm text-gray-500">{cours.nb_pages || 0} pages</p></div>
                <div className="flex gap-2"><span className="text-green-600 font-semibold">{cours.prix?.toLocaleString() || 0} F</span><button onClick={() => navigate(`/enseignant/cours/${cours.id_cours}/pages`)} className="text-blue-600 hover:text-blue-700">Gérer →</button></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}